module.exports = __webpack_public_path__ + "fonts/Gibson-Italic.8000df0c.woff";